module.exports = __webpack_public_path__ + "img/ps-31.73b03e96.jpg";